module.exports = __webpack_public_path__ + "static/media/trial3_2.7e5f3d6e.png";